// 우리은행 SMS입출금통지 등록 안내(design §12.4, 2026-06-16 라이브 실측).
// 카피/데이터만 — 렌더는 BankRegistrationGuide가 한다.

import type { GuideStep } from './BankRegistrationGuide';

export const GATEWAY_NUMBER_DISPLAY = '010-6443-3712';

// 인증번호를 요청하기 전까지 우리은행 앱에서 따라갈 단계.
export const WOORI_REQUEST_CODE_STEPS: GuideStep[] = [
  { title: '우리은행 모바일 앱(우리WON뱅킹) → 전체메뉴 → 설정' },
  { title: '푸시 알림 설정 → 문자/카카오알림톡' },
  { title: 'SMS 입출금통지서비스 → 신청 → 동의' },
  { title: '신청구분: "다른 휴대폰 / 여러 대" 선택' },
  { title: '입출금 알림 선택: "입출금" 또는 "입금" 선택' },
  {
    title: '"휴대폰인증"의 "휴대폰번호"에 아래 셀러헬퍼 번호 입력',
    detail: `내 휴대폰 번호가 아니라 ${GATEWAY_NUMBER_DISPLAY}를 입력해주세요.`,
    detailTone: 'danger',
  },
];

// 셀러헬퍼에 표시된 인증번호를 은행 앱에 입력한 뒤 마무리할 단계.
export const WOORI_COMPLETE_REGISTRATION_STEPS: GuideStep[] = [
  { title: '[휴대폰번호 추가]를 꼭 눌러야 등록 완료돼요', detail: '이 버튼을 안 누르면 등록되지 않아요.' },
];

// 통지옵션(1원/실입금 확인이 되려면 필요).
export const WOORI_NOTIFY_OPTIONS: GuideStep[] = [
  { title: '알림 금액: 모두' },
  { title: '알림 시간: 00~24시' },
];
